export const environment = {
  apiUrl: 'https://83oxr7ha2h.execute-api.eu-west-3.amazonaws.com/v1/',
  auth: {
    authority: 'https://cognito-idp.eu-west-3.amazonaws.com/eu-west-3_uuN96hePg',
    redirectUrl: globalThis.location.origin,
    clientId: '7eg21pelv6bbf1p386lc7s3dri',
    scope: 'openid',
    responseType: 'code',
    logoutUrl: 'https://sunleon-prd-user-pool-app.auth.eu-west-3.amazoncognito.com/logout'
  },
  sharePoint: {
    clientId: '3081f050-0d2b-4236-9f4b-e8602c77570b',
    tenantId: 'f48f023f-f1f2-4a42-92aa-bebb215f31d0',
    siteUrl: 'https://workplaceenergy.sharepoint.com/sites/VCI-PRProjets',
    defaultFolderPath: 'Documents partages/01_PROJETS'
  }
};
